import { query } from '@confluence/query-preloader-tools';

import { ContentAnalyticsViewersUnifiedQuery } from './queries/ContentAnalyticsViewersUnifiedQuery.graphql';

export const preloadContentAnalyticsViewers = (contentId: string) =>
	query({
		query: ContentAnalyticsViewersUnifiedQuery,
		variables: { contentId },
	});
